import React from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import DashboardExtended from '../components/DashboardExtended';
import NavMenu from '../components/NavMenu';
import Instances from '../components/Instances';
import AddInstancePage from '../components/AddInstancePage';
import EditInstancePage from '../components/EditInstancePage';
import Events from '../components/Events';
import Audits from '../components/Audits';
import Settings from '../components/Settings';
import EventInstanceHistory from "../components/EventInstanceHistory";
// import NotFoundPage from '../components/NotFoundPage'; 
  
const AppRouter = () => (
    <BrowserRouter>
        <div>
            <NavMenu />
            <Switch>
                <Route path="/Dashboard" component={Dashboard} />
                <Route path="/" component={Dashboard} exact={true} />
                <Route path="/All" component={DashboardExtended} />
                <Route path="/Instances" component={Instances} />
                <Route path="/create" component={AddInstancePage} />
                <Route path="/edit/:id" component={EditInstancePage}/>
                <Route path="/Events" component={Events} />
                <Route path="/Audits" component={Audits} />
                <Route path="/Settings" component={Settings} />
                <Route path="/History/:tag/Instance/:id/" component={EventInstanceHistory} />
            </Switch>
        </div>
      </BrowserRouter>
);
export default AppRouter;


// WEBPACK FOOTER //
// ./src/routers/AppRouter.js